<template>
    <div class="video-brightness-slider">
        <b-form-slider
            v-b-tooltip.hover
            orientation="horizontal"
            :value="brightness"
            :title="$translate('change_brightness')"
            :min="0"
            :max="3"
            :step="0.05"
            class="brightness-slider"
            @change="setBrightness"
        />
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'VideoBrightnessSlider',
    computed: {
        ...mapState({
            focusedWell: state => state.timelapse.focusedWell
        }),
        brightness() {
            return this.focusedWell.brightness
        }
    },
    methods: {
        setBrightness(valueObject) {
            this.$log.videoEvent('brightness_changed')

            this.$store.commit('timelapse/wellBrightness', valueObject.newValue)
        }
    }
}
</script>

<style lang="scss">
.video-brightness-slider {
    .brightness-slider {
        display: flex !important;
        width: 100%;
        height: 20px;
        padding: 0 10px;
        border-radius: 5rem;
        background-color: $dark-4;

        .slider.slider-horizontal {
            height: 20px;
            width: 100%;

            .slider-track {
                height: 5px;
                background-image: none;
                background-color: $dark-3;
                transform: translateY(-50%);
                margin-top: 0;

                .slider-track-low,
                .slider-track-high,
                .slider-selection {
                    background-image: none;
                }

                .slider-selection {
                    background-color: $blue;
                }
            }

            .slider-handle {
                background-image: none;
                background-color: $blue;
                border: 0.4rem solid $dark-4;

                &:hover {
                    border-color: $dark-5;
                }
            }
        }
    }
}
</style>
